<nav class="layout-breadcrumb">
    <ol>
        <li class="viewname">{{menuItem.label}}</li>
    </ol>
</nav>